import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { DeleteJson } from '@awp/helpers/fetchReact';
import AwpYesNoModal from '@components/Common/AwpYesNoModal';
import { REST_API, EventTypes } from '@awp/constants';
import { endDateValidator, dateBuilder } from '@awp/components/Common/Helpers/AwpDateHelper';
import { addDays } from 'date-fns';

const EventDeleteButton = ({ event, startDate, setStartDate, endDate, setEndDate }) => {
  const [showYesNoModal, setShowYesNoModal] = useState(false);
  const url = REST_API.PROCESSED_PHASED + event.EventId;
  const confirmText =
    event.EventTypeNm === EventTypes.RoadClosure || event.EventTypeNm === EventTypes.AvalancheControl
      ? 'Deleting this event will delete ALL related child events. Are you sure you want to delete?'
      : 'Are you sure you want to delete?';
  const handleDelete = async () => {
    DeleteJson(url, {})
      .then((response) => {
        if (response.ok) {
          toast.success('Event has been deleted');
          setStartDate(startDate);
          setEndDate(dateBuilder(addDays(new Date(endDate.value), 1), endDate, endDateValidator(endDate)));
        } else {
          toast.error('Failed to delete Event');
        }
      })
      .finally(() => {
        setShowYesNoModal(false);
      });
  };

  return (
    <>
      <i className="fas fa-trash mx-1 my-1 awp-img-btn" title="Delete" onClick={() => setShowYesNoModal(true)}></i>
      <AwpYesNoModal
        showYesNoModal={showYesNoModal}
        setShowYesNoModal={setShowYesNoModal}
        onClickYes={handleDelete}
        title="Delete"
        body={confirmText}
      />
    </>
  );
};

EventDeleteButton.propTypes = {
  event: PropTypes.any,
};

export default EventDeleteButton;
